module.exports = __webpack_public_path__ + "img/powered-by-olsera.37e33bcb.svg";